export default "__VITE_ASSET__AUbJGf5n__";